import { createTypes } from "reduxsauce";

export default createTypes(
    `
    SET_MAX_STEP
    SET_CURRENT_STEP

    FETCH_SLOTS_SUCCESS
    FETCH_SLOTS_REQUEST
    FETCH_SLOTS_FAILURE

    BOOK_SLOT_REQUEST
    BOOK_SLOT_SUCCESS
    BOOK_SLOT_FAILURE

    GET_ORDER_DETAIL_INIT
    GET_ORDER_DETAIL_SUCCESS
    GET_ORDER_DETAIL_FAILURE

    SET_SELECTED_SLOT
    SET_RECHEDULE_FLAG

    CANCEL_SLOT_INIT
    CANCEL_SLOT_SUCCESS
    CANCEL_SLOT_FAILURE
    RESET_CANCEL_RESCHEDULE_POPUP_STATE
    SET_TEST_DRIVE_VARIANT_INIT
    SET_TEST_DRIVE_VARIANT_SUCCESS
    SET_TEST_DRIVE_VARIANT_FAILURE
    UPDATE_SLOT_RESCHEDULE

    GET_TEST_DRIVE_VARIANT_INIT
    GET_TEST_DRIVE_VARIANT_SUCCESS
    GET_TEST_DRIVE_VARIANT_FAILURE

    FETCH_CMS_CONFIG_INIT
    FETCH_CMS_CONFIG_SUCCESS
    FETCH_CMS_CONFIG_FAILURE

    /* Basic details flow UI state */
    SET_BASIC_FLOW_ACTIVE_STEP
    SET_BASIC_FLOW_FINANCE_OPTION
    SET_BASIC_FLOW_DETAILS_COMPLETE
    SET_BASIC_FLOW_FINANCING_COMPLETE
    SET_BASIC_FLOW_RESCHEDULE_REASON
    SET_BASIC_FLOW_RESCHEDULE_OTHER
    OPEN_BASIC_FLOW_BOOKING_MODAL
    CLOSE_BASIC_FLOW_BOOKING_MODAL
    SET_BASIC_FLOW_NEXT_LOADING
    RESET_SINGLE_PAGE_TEST_DRIVE_STATE
`,
    {
        prefix: "book-test-drive/"
    }

);
